<template>
    <div></div>
</template>
<script>
export default {
    props: {
        value: {type: Object, default: () => ({})},
        init: Boolean
    },
    methods: {
        validate() {
            return Promise.resolve();
        }
    }
};
</script>


